import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helpersNumbers from "../../../../helpers/numbers";
import sizesBanner from "./../sizes-banner";
import ButtonDisable from "../../../partials/other/ButtonDisable";

export default function AddPositions() {
  const params = useParams();
  const sitePublisherID = parseInt(params.publisherID);
  const [message, setMessage] = useState();
  const [count, setCount] = useState(0);
  const [basePrice, setBasePrice] = useState(10000);
  const [price, setPrice] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [activeAlternative, setActiveAlternative] = useState(true);
  const history = useHistory();
  const [sitePublisher, setSitePublisher] = useState();
  const [imageSitePublisher, setImageSitePublisher] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    changePrice();
  }, [count]);

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-6 col-md-2 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="جایگاه های مستقل سایت  batmatic-test.ir" />
        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  className="btn btn-primary"
                  to="/positions/independent/all/web-site-publisher/1"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>
                <form>
                  <div className="form-group">
                    <label>تعداد بنر در جایگاه</label>
                    <input
                      tabIndex="1"
                      dir="ltr"
                      type="number"
                      id="count"
                      onChange={(e) => {
                        e.preventDefault();
                        setCount(parseInt(e.target.value));
                      }}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>مبلغ پایه </label>
                    <input
                      tabIndex="2"
                      type="text"
                      id="price"
                      className="form-control number-finance"
                      value={helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(basePrice)
                      )}
                      onChange={inputPriceChangeHandler}
                      onBeforeInput={inputPriceBeforeInputHandler}
                      dir="ltr"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>مبلغ نمایش یک تبلیغ در یک شبانه روز :‌ </label>
                    <span
                      className="letter-spacing-finance-number"
                      style={{ fontSize: "22px" }}
                    >
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(price)
                      )}
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="pl-2">فعال بودن تبلیغ جایگزین بنری</label>
                    <span>
                      <label className="adl-switch">
                        <input
                          type="checkbox"
                          id="active-advertise-alternative"
                          checked={activeAlternative}
                          onChange={() => {
                            setActiveAlternative(!activeAlternative);
                          }}
                        />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </div>

                  {activeAlternative && (
                    <div className="form-group">
                      <label>
                        امتیاز نمایش یک تبلیغ بنری جایگزین در یک شبانه روز :{" "}
                      </label>
                      <span
                        className="letter-spacing-finance-number"
                        style={{ fontSize: "22px" }}
                      >
                        {price <=
                        parseInt(
                          process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION
                        )
                          ? helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(price)
                            )
                          : helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                process.env
                                  .REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION
                              )
                            )}
                      </span>
                    </div>
                  )}

                  <div className="form-group">
                    <div className="pb-3">
                      <label>
                        اندازه بنرهای تبلیغاتی ( ارتفاع - عرض) پیکسل
                      </label>
                      <div className="container-fluid">
                        <div className="row">{generateButtonsSize()}</div>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="pl-0 pl-md-2">
                        <label>ارتفاع</label>
                        <input
                          dir="ltr"
                          type="number"
                          id="height"
                          value={height || ""}
                          className="form-control"
                          required
                        />
                      </div>
                      <div>
                        <label>عرض</label>
                        <input
                          dir="ltr"
                          type="number"
                          id="width"
                          value={width || ""}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <span className="pl-2">
                      <label>فعال</label>
                    </span>
                    <span>
                      <label className="adl-switch">
                        <input type="checkbox" id="active" />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </div>

                  <div className="form-group">
                    <ButtonDisable
                      buttonTagHtml={
                        <span className="btn btn-success opacity-50">
                          اضافه کردن
                        </span>
                      }
                    ></ButtonDisable>
                  </div>

                  <div className="form-group">
                    <div className="border border-success">
                      <a href={imageSitePublisher} target="_blank">
                        <img className="img-fluid" src={imageSitePublisher} />
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
